import React from 'react';
import classNames from 'classnames';
import type { ActiveFiler } from '@lt/components/components/HotelCard/components/FiltersPenalized';
import PenalizedFilterLabel from './components/PenalizedFilterLabel/PenalizedFilterLabel';
import styles from './hotelCardPenalizedFilters.module.css';
import { PENALIZED_FILTERS_TEST_ID } from './constants';

type HotelCardPenalizedFiltersProps = {
  penalizedFilters: ActiveFiler[];
  isMobile: boolean;
};

const HotelCardPenalizedFilters: React.FC<HotelCardPenalizedFiltersProps> = ({
  penalizedFilters,
  isMobile,
}) =>
  penalizedFilters.length > 0 ? (
    <div
      className={classNames(styles.penalizedFilters, {
        [styles.penalizedFiltersMobile]: isMobile,
      })}
      data-testid={PENALIZED_FILTERS_TEST_ID}
    >
      {penalizedFilters.map((filter) => (
        <PenalizedFilterLabel key={filter.filterName}>
          <span>{`${filter.filterGroupLabel}:`}&nbsp;</span>
          <span>{filter.filterValue}</span>
        </PenalizedFilterLabel>
      ))}
    </div>
  ) : null;

export default HotelCardPenalizedFilters;
